import isAuthorized, { getUser } from '@/helpers/auth';

function redirectBasedOnRole() {
    const user = getUser();
    let path;

    if (!user) return;

    switch (user.user_type) {
    case 'admin':
        path = '/admin/resellers';
        break;
    case 'reseller':
        path = '/resellers';
        break;
    case 'client':
        path = '/clients';
        break;
    default:
        path = '/logout';
    }

    return path;
}

function checkIfAuthorized(next) {
    if (isAuthorized()) {
        next({
            path: '/',
        });
    } else {
        next();
    }
}

function redirectResellerBasedOnSetup() {
    const user = getUser();
    let path;

    if (!user) return;
    if (!user.reseller) return;

    if (user.reseller.setup_completed === false || user.reseller.setup_completed === 0) {
        path = '/resellers/summary';
    } else {
        path = '/resellers/dashboard';
    }

    return path;
}

export { checkIfAuthorized, redirectResellerBasedOnSetup };

export default redirectBasedOnRole;
